'use es6';

import { fromJS, List, Record } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
import { AdWordsCalloutAdExtensionRecord, AdWordsFeedItemSchedule, AdWordsSiteLinkAdExtensionRecord } from 'AdsUI/records/rmf/AdWordsExtensionRecords';
import { AdExtensionTypes } from 'AdsUI/lib/Constants';
import { omit } from 'AdsUI/lib/Utils';
const initialState = new Record({
  adExtensions: List(),
  uiModalAdExtension: null
})();
const extensionTypeToRecord = {
  [AdExtensionTypes.CALLOUT]: props => new AdWordsCalloutAdExtensionRecord(props),
  [AdExtensionTypes.SITELINK]: props => new AdWordsSiteLinkAdExtensionRecord(props)
};

const getDefaultUIExtension = function getDefaultUIExtension(state, {
  accountId
}) {
  const ext = new AdWordsSiteLinkAdExtensionRecord({
    accountId
  });
  return state.set('uiModalAdExtension', ext);
}; // take the newExt, and replace the existing one w same feedItemId in adExtensions


const updateExtension = function updateExtension(state, newExt, oldId) {
  const extList = state.get('adExtensions');
  const idToCheck = oldId || newExt.feedItemId || newExt.campaignId;
  const index = extList.findIndex(ext => {
    return ext.feedItemId === idToCheck || ext.campaignId === idToCheck;
  }); // store the old one somewhere until success?

  return state.mergeIn(['adExtensions'], state.get('adExtensions').set(index, newExt));
};

export default ((state = initialState, action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Actions.AD_EXTENSION_FETCH_SUCCEEDED:
    case Actions.AD_LOCATION_EXTENSION_FETCH_SUCCEEDED:
      {
        if (payload) {
          // go through payloads and create a record for each based on type
          const extensions = fromJS(payload.map(ext => {
            if (ext.locationFeedItemIds) {
              ext.locationFeedItemIds = fromJS(ext.locationFeedItemIds);
            }

            const recordType = extensionTypeToRecord[ext.extensionType];
            return recordType(ext);
          }));
          state = state.set('adExtensions', state.get('adExtensions').concat(extensions));
        }

        break;
      }

    case Actions.AD_EXTENSION_CREATE_START:
      // Add new extension to list
      state = state.mergeIn(['adExtensions'], state.get('adExtensions').push(payload));
      break;

    case Actions.AD_EXTENSION_CREATE_SUCCEEDED:
      {
        // replace the null valued record w the new one rfom server
        // this assumes no other actions have happened since we hit create
        if (payload) {
          const createdExt = payload;

          if (createdExt.locationFeedItemIds) {
            createdExt.locationFeedItemIds = fromJS(createdExt.locationFeedItemIds);
          }

          const recordType = extensionTypeToRecord[payload.extensionType];
          state = state.set('adExtensions', state.get('adExtensions').set(-1, recordType(createdExt))); // reset ui state

          state = getDefaultUIExtension(state, payload);
        }

        break;
      }

    case Actions.AD_EXTENSION_CREATE_FAILED:
      // Pop off last item in list
      state = state.setIn(['adExtensions'], state.get('adExtensions').pop());
      break;

    case Actions.AD_EXTENSION_SAVE_START:
      // swap the UI one for the real one
      state = updateExtension(state, state.get('uiModalAdExtension'));
      state = getDefaultUIExtension(state, payload);
      break;

    case Actions.AD_EXTENSION_SAVE_SUCCEEDED:
      // These dam things are immutable.
      if (payload) {
        const recordType = extensionTypeToRecord[payload.extensionType];
        state = updateExtension(state, recordType(omit(payload, 'oldFeedItemId')), payload.oldFeedItemId);
      }

      break;

    case Actions.AD_EXTENSION_SAVE_FAILED:
      break;

    case Actions.AD_EXTENSION_UI_CHANGE_TYPE:
      {
        // switch extensionType, but preserve properties that are common on the base record
        const recordType = extensionTypeToRecord[payload.type];
        const accountId = state.getIn(['uiModalAdExtension', 'accountId']); // TODO: Copy over the common fields between the records?

        state = state.set('uiModalAdExtension', recordType({
          accountId
        }));
        break;
      }

    case Actions.AD_EXTENSION_UI_UPDATE:
      // should always be an ad extension record
      state = state.mergeIn(['uiModalAdExtension'], payload);
      break;

    case Actions.AD_EXTENSION_UI_SET:
      state = state.set('uiModalAdExtension', payload);
      break;

    case Actions.AD_EXTENSION_UI_SET_DEFAULT:
      state = getDefaultUIExtension(state, payload);
      break;

    case Actions.AD_EXTENSION_DELETE_START:
      {
        // take new extension from UI, update the existing one in the list
        let indexToDelete;
        const extList = state.get('adExtensions');

        if (payload.feedItemId) {
          indexToDelete = extList.findIndex(ext => {
            return ext.feedItemId === payload.feedItemId;
          });
        } else {
          // location extensions have no feed item id and are only one per campaign
          indexToDelete = extList.findIndex(ext => {
            return ext.campaignId === payload.campaignId;
          });
        }

        state = state.set('adExtensions', state.get('adExtensions').delete(indexToDelete));
        break;
      }

    case Actions.AD_EXTENSION_UI_ADD_FEED_ITEM_SCHEDULE:
      {
        let feedItemSchedules = state.getIn(['uiModalAdExtension', 'feedItemSchedules']); // May come as null from API

        if (feedItemSchedules) {
          feedItemSchedules = feedItemSchedules.push(new AdWordsFeedItemSchedule());
        } else {
          feedItemSchedules = new List([new AdWordsFeedItemSchedule()]);
        }

        state = state.setIn(['uiModalAdExtension', 'feedItemSchedules'], feedItemSchedules);
        break;
      }

    case Actions.AD_EXTENSION_UI_REMOVE_FEED_ITEM_SCHEDULE:
      state = state.setIn(['uiModalAdExtension', 'feedItemSchedules'], state.getIn(['uiModalAdExtension', 'feedItemSchedules']).delete(payload.index));
      break;

    case Actions.AD_EXTENSION_UI_UPDATE_FEED_ITEM_SCHEDULE:
      state = state.setIn(['uiModalAdExtension', 'feedItemSchedules'], state.getIn(['uiModalAdExtension', 'feedItemSchedules']).update(payload.index, item => item.merge(payload.data)));
      break;

    default:
      break;
  }

  return state;
});